<template>
    <div class="search-table">
            <div class="sectionTop backgroundOrange colorWhite">
                <div class="origin">
                    <p>مبدا</p>
                    <span>{{$store.state.flight.departure.region}}</span>
                </div>
                <div class="travelSidesImg">
                    <img src="/images/blittosides.png" alt="" @click="changeFlightSides()">
                </div>
                <div class="destination">
                    <p>مقصد</p>
                    <span>{{$store.state.flight.destination.region}}</span>
                </div>
                <div class="passengerQuantity">
                    <p>تعداد مسافر</p>
                    <div class="row" v-for="(value,key,i) in $store.state.flight.passengers" v-show="value!=0"  :key="i++">
                        <span><span>{{value}}</span> نفر {{getPersianPassenger(key)}}</span>
                    </div>
                </div>
            </div>
            <div class="sectionBottom">
                <flickity ref="flickity" :options="getFlickityOptions()">
                    <div class="dateSections" v-for="(date,i) in getArray()" :key="i" @click="selectIndex(i,date.date)">
                        {{date.persian}}
                    </div>
                </flickity>
            </div>
        </div>
</template>

<script>
import Flickity from 'vue-flickity';
import moment from 'moment-jalaali'
export default {
    props:['data'],
    data(){
    return {
        flickityOptions: {
        initialIndex:'',
        prevNextButtons: false,
        pageDots: false,
        rightToLeft: true,
        // any options from Flickity can be used
        },
        localDepartureDate:this.$store.state.flight.data.departureDate,
        localReturnDate:this.$store.state.flight.data.returnDate,
        localSelectedIndex:'',
        departureDateArray:[],
        returnDateArray:[],
        currentDate:this.$store.state.flight.currentDate
    }
    },
    computed:{
        getCurrentDate(){
            return this.$store.state.flight.currentDate
        }
    },
    methods: {
        getArray(){
            return this.departureDateArray
        },
        buildDateArray:function(){
            if(this.$store.state.flight.currentDate=='departure'){
                this.departureDateArray=[]
                let selectedDate = new Date(moment(this.localDepartureDate, 'jYYYY-jM-jD'));
                let today = new Date();
                var timeDiff = selectedDate.getTime() - today.getTime();
                var days = (timeDiff / (1000 * 3600 * 24));
                if(days<0){
                    days=0
                }else{
                    days = Math.floor(days)+1
                }

                for(let i = 0; i <= (30+parseInt(days)); i++ ){
                    let rangeDates=moment(new Date(today.getTime() + i*86400000)).format('jYYYY-jM-jD')
                    let dayOfMonth=moment(new Date(today.getTime() + i*86400000)).format('jD')
                    let month=moment(new Date(today.getTime() + i*86400000)).format('jMMMM')
                    let enDays=[
                        'Farvardin'
                        , 'Ordibehesht'
                        , 'Khordaad'
                        , 'Tir'
                        , 'Mordaad'
                        , 'Shahrivar'
                        , 'Mehr'
                        , 'Aabaan'
                        , 'Aazar'
                        , 'Dey'
                        , 'Bahman'
                        , 'Esfand'
                    ]
                    let faDays=[
                        'فروردین'
                        , 'اردیبهشت'
                        , 'خرداد'
                        , 'تیر'
                        , 'مرداد'
                        , 'شهریور'
                        , 'مهر'
                        , 'آبان'
                        , 'آذز'
                        , 'دی'
                        , 'بهمن'
                        , 'اسفند'
                    ]
                    for(var x= 0; x < enDays.length; x++) {

                        month = month.replace(new RegExp(enDays[x], 'g'),faDays[x]);

                    }

                    let dayOfWeek=this.toPersian(new Date(today.getTime() + i*86400000).getDay())
                    let obj={date:rangeDates,persian:`${dayOfWeek} ${dayOfMonth} ${month}`}
                    this.departureDateArray.push(obj)
                }
                this.localSelectedIndex=days
                if(days==0){
                    this.localSelectedIndex=days
                }

                this.flickityOptions.initialIndex=this.localSelectedIndex
            }
            else if(this.$store.state.flight.currentDate=='return'){
                this.returnDateArray=[]

                let selectedDate = new Date(moment(this.localReturnDate, 'jYYYY-jM-jD'));
                let today = new Date()

                var timeDiff = selectedDate.getTime() - today.getTime();
                var days = (timeDiff / (1000 * 3600 * 24));
                if(days<0){
                    days=0
                }else{
                    days = Math.floor(days)+1
                }

                for(let i = 0; i <= (30+parseInt(days)); i++ ){
                    let rangeDates=moment(new Date(today.getTime() + i*86400000)).format('jYYYY-jM-jD')
                    let dayOfMonth=moment(new Date(today.getTime() + i*86400000)).format('jD')
                    let month=moment(new Date(today.getTime() + i*86400000)).format('jMMMM')
                    let dayOfWeek=this.toPersian(new Date(today.getTime() + i*86400000).getDay())
                    let obj={date:rangeDates,persian:`${dayOfWeek} ${dayOfMonth} ${month}`}
                    this.returnDateArray.push(obj)
                }
                this.localSelectedIndex=days
                this.flickityOptions.initialIndex=this.localSelectedIndex
            }
        },
        getFlickityOptions(){
            this.flickityOptions.initialIndex=this.localSelectedIndex
            return this.flickityOptions
        },

        selectIndex(i){
            this.$refs.flickity.selectCell(i);
        },
        toPersian(i){

            switch(i){
                case 6:
                    return 'شنبه';
                case 0:
                    return 'یک شنبه';
                case 1:
                    return 'دوشنبه';
                case 2:
                    return 'سه شنبه';
                case 3:
                    return 'چهارشنبه';
                case 4:
                    return 'پنجشنبه';
                case 5:
                    return 'جمعه';
            }
        },
        getPersianPassenger(key){
            switch(key){
                case 'adult':
                    return 'بزرگسال';
                case 'child':
                    return 'کودک';
                case 'infant':
                    return 'نوزاد';
            }
        },
        changeFlightSides:function(){
            let departure = this.$store.state.flight.departure;
            let destination = this.$store.state.flight.destination
            this.$store.state.flight.departure=destination
            this.$store.state.flight.destination=departure
            this.$store.state.flight.data.departure=destination.iataCode
            this.$store.state.flight.data.destination=departure.iataCode
            this.$store.dispatch('searchFlights',this.$store.state.flight.data)
            this.$emit('filter',{
                time:'all',
                seatClass:'allseats',
                charter:'allmodes'
            })
            thself.$store.state.flight.data.returnDateis.$emit('sort',{
                sortBy:'price',
                sortAscending:false
            })
        }
    },
    components:{
        Flickity
    },
    watch:{
        getCurrentDate(val){
            this.buildDateArray()
        },
        localSelectedIndex:function(val){
            this.selectIndex(val)
        }
    },
    mounted(){
        var self = this
        this.buildDateArray()
        let counter=0
        setTimeout(() => {
            if(counter==0){
            counter++
            self.$refs.flickity.rerender()
            self.$refs.flickity.on('change',function(){
            self.$emit('filter',{
                time:'all',
                seatClass:'allseats',
                charter:'allmodes'
            })
            self.$emit('sort',{
                sortBy:'price',
                sortAscending:false
            })
            if(self.$store.state.flight.currentDate=='departure'){
            self.buildDateArray()
            self.$store.state.flight.data.departureDate=self.departureDateArray[self.$refs.flickity.selectedIndex()].date
            }
            else if(self.$store.state.flight.currentDate=='return'){
                self.buildDateArray()
                self.$store.state.flight.data.returnDate=self.returnDateArray[self.$refs.flickity.selectedIndex()].date
            }
            self.$store.state.flight.data.page=0
            self.$store.dispatch('searchFlights',self.$store.state.flight.data)
            })
            }
        }, 0);
    }
}
</script>

<style>
@media (max-width:768px){
    .ticketCenterPart{
        margin-top: 12px;
    }
    .sectionBottom{
    padding: 0 32px !important;
    }
    .sectionBottom .dateSections{
        margin: 16px 0
    }
    .ticketList div > div.logo{
        margin:0
    }
}

</style>
